import { type ReactElement, useCallback } from 'react'
import type AccordionProps from './accordion.props'
import arrow from './assets/discount-arrow.svg'
import * as S from './discount-accordion.styled'

export default function DiscountAccordion ({ isOpen = false, ...props }: AccordionProps): ReactElement {
  const handleOpen = useCallback(() => {
    if (!isOpen) {
      props.onOpen(props.index)
      return
    }

    props.onOpen(undefined)
  }, [isOpen, props.index, props.onOpen])

  return <S.Container>
    <div className="title-container" onClick={handleOpen}>
      <div>
        {props.titleImages?.map((image, i) => <img key={i} src={image} alt="" />)}
        <p>{props.title}</p>
      </div>
      <img src={arrow} alt="" className={`icon ${isOpen ? 'open' : ''}`} />
    </div>
    <div className={`content ${isOpen ? 'open' : ''}`}>
      {props.children}
    </div>
  </S.Container>
}
